import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class EpicTextImgSection extends Vue {
    @Prop({ default: '#ECF8FA'})
    public bgColor!: string;
    @Prop({ default: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-download/graphic01.png'})
    public img!: string;
    @Prop({ default: false})
    public reverse!: boolean;
    @Prop({ default: 'Build For Client'})
    public title!: string;
    @Prop({ default: `No matter whether you are house buyer or renter,
     We aim at building the best client system to help you find the right home for the right price.
     <br/><br/>We offer all kinds of buying and renting house services, please feel free to contact us for any assistances.`})
    public paragraph!: string;
    @Prop({ default: 'Contact Us'})
    public buttonTxt!: string;
    @Prop({ default: ''})
    public buttonHref!: string;
}
